export const config = {
  NODE_ENV: process.env.NODE_ENV,
  APP_ENV: process.env.REACT_APP_ENV,

  API_URL: process.env.REACT_APP_API_URL,
  // API_URL: process.env.REACT_APP_LOCAL_API_URL, // local
  APP_URL: `${process.env.REACT_APP_URL}`,
  APP_URL_APPLE_PAY: `${process.env.REACT_APP_URL_APPLE_PAY}`,
  SOCKET_URL: `${process.env.REACT_APP_SOCKET_URL}`,
  GUEST_API_URL: process.env.REACT_APP_GUEST_API_URL,
  LOCAL_API_URL: process.env.REACT_APP_LOCAL_API_URL,
  GUEST_LOCAL_API_URL: process.env.REACT_APP_GUEST_LOCAL_API_URL,

  STRIPE_KEY: `${process.env.REACT_APP_STRIPE_KEY}`,
  BRAINTREE_KEY: `${process.env.REACT_APP_BRAINTREE_KEY}`,
  LIVE_COMPANY: `${process.env.REACT_APP_COMPANY_URL}`,
  SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN,

  GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,

  MAX_KM_PER_HOUR: Number(process.env.REACT_APP_MAX_KM_PER_HOUR) || 0,
  ENCRYPTION_KEY: process.env.REACT_APP_ENCRYPT_KEY,
  GOOGLE_MAPS_API_URL: process.env.REACT_APP_GOOGLE_MAPS_API_URL,

  /** Local dev only — force HyperPay checkout mode. Values: 'unified' | 'split' | '' */
  HYPERPAY_TEST_MODE: process.env.REACT_APP_HYPERPAY_TEST_MODE || "",
};

// In your config file
export const EXTRA_CONFIG = {
  UNLIMITED_KM_ID:
    process.env.REACT_APP_UNLIMITED_KM_ID || "68ef73959cbcbe2ab79cecf7",
  ADDITIONAL_DRIVER_ID:
    process.env.REACT_APP_ADDITIONAL_DRIVER_ID || "69410aff37be7ffba633c2e4",

  // Optional: You could also store seat IDs if you want to handle them specially
  SEAT_EXTRAS: {
    CHILD_SEAT_ID: "690237a7121d6ac44b95badb",
    BABY_SEAT_ID: "694109f337be7ffba633c2d0",
    BOOSTER_SEAT_ID: "69410a6e37be7ffba633c2d7",
  },
};
